import {on, findAllIn, findIn, closest} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";

export function init() {
    onFind('.js-address-form', function (baseElement) {
        let toggle = findIn('.js-address-form__toggle', baseElement);
        let toggleInput = findIn('.js-address-form__input', baseElement);

        on('click', function () {
            toggleInput.checked = !toggleInput.checked;
        }, toggle)

    });
}